<template>
    <div class="activity">
        <div class="mytitle">
            <span></span>
        </div>

        <ul>
            <li v-for="item in activityList" :key="item.activityId" @click="activityClick(item)">
                <img :src="UPLOAD_FILE_PATH+item.activityFileUrl" alt="" />
                <p>{{ item.activityName }}</p>
            </li>
        </ul>
        <div style="height: 50px;"></div>
    </div>
</template>

<script>
import {getActivityList,UPLOAD_FILE_PATH} from "@/https/http.js";

export default {
    name: 'activity',
    data(){
        return{
            rent:JSON.parse(localStorage.getItem("rent")),
            UPLOAD_FILE_PATH:UPLOAD_FILE_PATH,
            activityList:[]
        }
    },
    created(){
        this.queryActivityList();
    },
    methods: {
        activityClick(item) {
            if(item.activityUrl&&item.activityUrl!=''){
                window.open(item.activityUrl)
            }else{
                this.$router.push({path:'/activityDetail/'+this.rent.rentPath,query:{activityId:item.activityId}})
            }
        },
        queryActivityList(){
            getActivityList(this.rent).then(res=>{
                this.activityList=res.data
            })
        }
    }
}
</script>

<style lang="less" scoped>
.activity {
    .mytitle {
        text-align: center;
        font-size: 16px;
        margin-top: 20px;
        position: relative;
        height: 50px;
        span {
            width: 50%;
            height: 2px;
            background-color: #ccc;
            display: inline-block;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        h3 {
            width: 30%;
            background-color: #fff;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
    ul {
        margin-left: 2%;
        margin-right: 2%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li {
            width: 100%;
            img {
                width: 100%;
            }
            p {
                text-align: center;
                font-size: 16px;
            }
        }
    }
}
</style>